import React, { useEffect } from "react";
import Modal from "../ui/Modal";
import Form, { FormField } from "../ui/Form";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as tenantUserActions from "src/redux/slices/tenantUserSlice";
import * as tenantActions from "src/redux/slices/tenantSlice";
import { toast } from "react-toastify";
import { genderOptions, tenantRoleOptions } from "src/constants/common";

interface AddTenantUserModalProps {
  open: boolean;
  userData: any;
  onClose: () => void;
  tenantId: string;
  type?: "admin" | "manager";
}

const AddTenantUserModal: React.FC<AddTenantUserModalProps> = ({
  open,
  userData = null,
  onClose,
  tenantId,
  type = "admin",
}) => {
  const dispatch = useAppDispatch();
  const { createTenantUser, editTenantUser } = useAppSelector(
    (state) => state.tenantUser
  );
  const { tenantRoleList } = useAppSelector((state) => state?.tenant);
  console.log("TenantRole", tenantRoleList);

  useEffect(() => {
    dispatch(
      tenantActions.getTenantRoleListRequest({
        tenantId,
        isAdminAuth: true,
      })
    );
  }, [dispatch, tenantId]);

  // ✅ Success/Error side-effects
  useEffect(() => {
    if (createTenantUser.data) {
      toast.success("Tenant User created successfully");
      handleClose();
    } else if (createTenantUser.error) {
      toast.error(`Error: ${createTenantUser.error}`);
    }
  }, [createTenantUser]);

  // ✅ Success/Error side-effects
  useEffect(() => {
    if (editTenantUser.data) {
      toast.success("Tenant User hihi modified successfully");
      handleClose();
    } else if (editTenantUser.error) {
      toast.error(`Error: ${editTenantUser.error}`);
    }
  }, [editTenantUser]);

  const handleClose = () => {
    dispatch(tenantUserActions.resetCreateTenantUser());
    dispatch(tenantUserActions.resetEditTenantUser());
    onClose();
  };

  // ✅ Define all form fields
  const fields: FormField[] = [
    {
      label: "First Name",
      name: "firstName",
      type: "text",
      placeholder: "Enter first name",
      validations: { required: true },
    },
    {
      label: "Last Name",
      name: "lastName",
      type: "text",
      placeholder: "Enter last name",
      validations: { required: true },
    },
    {
      label: "Email",
      name: "email",
      type: "text",
      placeholder: "Enter email address",
      validations: {
        required: true,
        regex: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
        message: "Invalid email format",
      },
    },
    {
      label: "Password",
      name: "password",
      type: "password",
      placeholder: "Enter password",
      validations: { required: true },
    },
    {
      label: "Date of Birth",
      name: "dob",
      type: "text",
      placeholder: "dd/mm/yyyy",
      validations: { required: true },
    },
    {
      label: "Gender",
      name: "gender",
      type: "dropdown",
      options: genderOptions,
      validations: { required: true },
    },
    {
      label: "Role",
      name: "role",
      type: "dropdown",
      // options: tenantRoleOptions,
      options:
        tenantRoleList?.data?.data?.map((tenantRole: any) => ({
          label: tenantRole?.name || "",
          value: tenantRole?._id || "",
        })) || [],
      validations: { required: true },
    },
  ];

  // ✅ Form submission handler
  const handleSubmit = (data: Record<string, any>) => {
    if (userData?._id) {
      dispatch(
        tenantUserActions.editTenantUserRequest({
          ...(data as any),
          _id: userData?._id,
          tenantId,
          isAdminAuth: true,
        })
      );
    } else {
      dispatch(
        tenantUserActions.createTenantUserRequest({
          ...(data as any),
          tenantId,
          isAdminAuth: true,
        })
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={type === "manager" ? "Add User" : "Add Tenant User"}
    >
      <Form
        initialState={userData as any}
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={onClose}
        loading={createTenantUser.loading}
      />
    </Modal>
  );
};

export default AddTenantUserModal;
